interface Props {
  receiptNumber: string;
  onClose: () => void;
}

export default function SuccessModal({ receiptNumber, onClose }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="bg-white rounded-2xl p-8 max-w-sm w-full text-center">
        <div className="w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4" style={{ backgroundColor: '#e8f5f1' }}>
          <i className="ri-check-line text-3xl" style={{ color: '#2E7D6B' }}></i>
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">신청이 완료되었습니다</h3>
        <p className="text-sm text-gray-500 mb-4">접수가 정상적으로 저장되었습니다.</p>
        <div className="bg-gray-50 rounded-xl p-3 mb-6">
          <p className="text-xs text-gray-400 mb-1">접수번호</p>
          <p className="text-lg font-bold text-gray-800 tracking-wider">{receiptNumber}</p>
        </div>
        <button
          onClick={onClose}
          className="w-full py-3 rounded-xl text-sm font-bold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
          style={{ backgroundColor: '#2E7D6B' }}
        >
          확인
        </button>
      </div>
    </div>
  );
}
